import { render } from "./CheckIcon.vue?vue&type=template&id=f582882e"
const script = {}
script.render = render

export default script